export default __webpack_public_path__ + "static/media/15-EXT-(4-3).ef975562.jpg";